<template>
  <div
    :class="$style.root"
  >
    <LayoutPageHeaderComponent :data="localizedData" />

    <ul :class="$style.list">
      <li
        :class="$style.item"
        v-for="(entry, index) in childData?.data"
      >
        <SharedThumbnailNewsComponent  :data="entry" />
      </li>
    </ul>

    <LayoutPaginationComponent
      :pagination="childData?.meta?.pagination"
      :paginateChildData="paginateChildData"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  pageData: Object,
  childData: {
    type: Object,
    required: false,
  },
  paginateChildData: {
    type: Function,
    required: false,
  }
})

const getLocalizedData = i18nGetLocalizedData

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})

const getTitle = (data) => i18nGetLocalizedTitle(data)
</script>

<style module>
.root {
}

.list {
  composes: reset-list container--default from global;
}

.item:not(:last-of-type) {
  margin-bottom: calc(var(--unit--vertical) - (var(--lh) - var(--fs)) + var(--stroke--default));
  padding-bottom: var(--unit--vertical);
  /* border-bottom: var(--stroke--default) solid; */
}
</style>
